import { createFileRoute, redirect } from '@tanstack/react-router'

import { getAuthState } from '@/lib/auth'
import { AgreementsPage } from '@/pages/AgreementsPage'

export const Route = createFileRoute('/agreements')({
  beforeLoad: async () => {
    // そもそも未認証の場合はログイン画面にリダイレクト
    // _authenticated配下に置いていないのは、_authenticatedでも規約チェックをしているのでredirectの無限ループが発生してしまうため
    const { isAuthenticated, shouldAgreeTerms } = await getAuthState()
    if (!isAuthenticated) {
      throw redirect({
        to: '/login',
      })
    }
    if (!shouldAgreeTerms) {
      throw redirect({
        to: '/trials',
      })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <AgreementsPage />
}
